import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS } from '../../../utils/constants';

export const TableHeadGestionPresupuestos = (props) => {

  const {
    order,
    orderBy,
    onRequestSort,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    { id: 'historial', align: "left", enabledSort: false, visible: true },
    { id: "estado", disablePadding: false, label: "Estado", align: "left", visible: true },
    { id: "fecha", disablePadding: false, label: "Fecha Carga", align: "left", enabledSort: true, visible: true },
    { id: "fechaDerivacion", disablePadding: false, label: "Fecha Derivación", align: "left", enabledSort: true, visible: props.estadoPresupuestos === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS },
    { id: "idPresupuesto", disablePadding: false, label: "N° Presupuesto", align: "left", enabledSort: true, visible: true },
    { id: "tipoPresupuesto.descripcionTipo", disablePadding: false, label: "Tipo", align: "left", enabledSort: true, visible: true, maxWidth: 50 },
    { id: "conInternacion", disablePadding: false, label: "Subtipo", align: "left", enabledSort: true, visible: true, maxWidth: 100 },
    { id: "diagnostico.problema", disablePadding: false, label: "Diagnostico", align: "left", enabledSort: true, visible: true },
    { id: "practicas", disablePadding: false, label: "Practicas", align: "left", enabledSort: false, visible: true },
    { id: "afiliado", disablePadding: false, label: "Paciente", align: "left", enabledSort: false, visible: true },
    { id: "nroAfiliado", disablePadding: false, label: "N° Afiliado", align: "left", enabledSort: false, visible: true },
    { id: "idSeccional", disablePadding: false, label: "Seccional", align: "left", enabledSort: false, visible: true },
    { id: "idBandejaAutorizacion", disablePadding: false, label: "Bandeja", align: "left", enabledSort: false, visible: true },
    { id: "idUsuarioTomada", disablePadding: false, label: "Tomado", align: "left", enabledSort: false, visible: props.estadoPresupuestos !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO && props.estadoPresupuestos !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO },
  ];


  return (
    <TableHead>
      <TableRow>
        {headCells.filter(s => s.visible).map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ minWidth: headCell.minWidth, maxWidth: headCell.maxWidth }}
          >
            {headCell.enabledSort
              ?
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
              :
              <>{headCell.label}</>
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

TableHeadGestionPresupuestos.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};